import { memo } from 'react';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';

type ErrorNudgeCardProps = {
  title: string;
  description?: string;
  onDismiss: () => void;
  testID?: string;
};

const closeButtonStyle = { cursor: 'pointer' };

export const ErrorNudgeCard = memo(function ErrorNudgeCard({
  title,
  description,
  onDismiss,
}: ErrorNudgeCardProps) {
  return (
    <VStack width="100%" borderRadius={300} background="bgNegativeWash">
      <HStack paddingY={2} paddingX={2} alignItems="center" justifyContent="space-between" gap={2}>
        <Icon name="error" size="s" color="fgNegative" />
        <VStack flexGrow={1} flexShrink={1}>
          <Text font="headline" color="fg">
            {title}
          </Text>
          {description && (
            <Text font="body" color="fg">
              {description}
            </Text>
          )}
        </VStack>
        <Box onClick={onDismiss} style={closeButtonStyle} flexShrink={0}>
          <Icon size="s" name="close" color="fg" />
        </Box>
      </HStack>
    </VStack>
  );
});
